import router from '@/router.js'
import langs from '@/data/langs.js'
import store from '@/store/index.js'


export default{
  get route() {
    return router.currentRoute
  },
  get path() {
    let items = router.currentRoute.path.split('/')
    if(langs.navlangs.includes(items[1]))
    {
      return '/' + items.splice(2).join('/')
    }
    return items.join('/')
  },
  get contactLink() {
    let lang = store.state.lang.toLowerCase()
    if(lang === 'uk'){
      return '/contact/uk'
    }
    return '/' + lang + '/contact/' + lang
  },
  getPushPath(path) {
    let mlang = store.state.langPref
    let lang = store.state.lang.toLowerCase()
    if(mlang) {
      lang = mlang.toLowerCase()
    }
    if(lang == 'uk'){
      return path
    }
    if(path === '/') {
      path = ''
    }
    if((path.indexOf('not-found') >= 0) || (path.indexOf('notfound') >= 0)) {
      return '/notfound.html'
    }
    return `/${lang}${path}`
  },
  getLangFromPath(path) {
    let pts = path.split('/')
    if(pts.length > 1){
      if(langs.navlangs.includes(pts[1])){
        return pts[1].toUpperCase()
      }
    }
    return 'UK'
  },
  push (path) {
    try {
      let pt = this.getPushPath(path)
      router.push(pt).catch(err =>  {
        console.log('ixr push caught error', err)
      })
    }
    catch(err) {
      console.log('unable to push path', err)
    }
    
  }
}